const impactTooltip = {
  L: 'Low Impact',
  M: 'Medium Impact',
  H: 'High Impact',
};

export { impactTooltip };
